module.exports = __webpack_public_path__ + "img/whiteDoubleTick.25b142f8.svg";